/**
 * Logger centralizado para o QuizFlow
 *
 * - log/warn/debug: visíveis apenas em DEV (silenciados em produção).
 * - error: além do console em DEV, encaminha SEMPRE para a fachada de
 *   telemetria (`captureException`), que roteia para o provider de crash
 *   reporting configurado em produção. Isso elimina a cegueira em prod —
 *   antes `logger.error` só escrevia no console, que é apagado pelo
 *   transform-remove-console no build de release.
 */

import { captureException } from '../services/telemetry';

const isDev = __DEV__;

export const logger = {
    log: (...args) => {
        if (isDev) {
            console.log(...args);
        }
    },
    warn: (...args) => {
        if (isDev) {
            console.warn(...args);
        }
    },
    error: (...args) => {
        if (isDev) {
            console.error(...args);
        }
        // Encaminha à telemetria em qualquer ambiente. O primeiro argumento
        // costuma ser o Error; o restante vira contexto diagnóstico.
        const [first, ...rest] = args;
        captureException(first, rest.length ? { extra: rest } : undefined);
    },
    debug: (...args) => {
        if (isDev) {
            console.debug(...args);
        }
    },
};

export default logger;
